import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { EditableCurrencyColumn } from './editable-currency-column';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const taxPaidColumnId = 'edit-tax-paid-column';

const TaxPaid = ({ value, updateRowProperty, row: { original } }) => {
  if (value.disabled) {
    return <ReadOnlyCurrencyColumn currencyValue={value} />;
  }
  return (
    <EditableCurrencyColumn columnId={taxPaidColumnId} currencyValue={value} original={original} updateRowProperty={updateRowProperty} />
  );
};

TaxPaid.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  }).isRequired,
  updateRowProperty: PropTypes.func.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string,
      [taxPaidColumnId]: PropTypes.shape({
        code: PropTypes.string,
        value: PropTypes.number,
        disabled: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

const taxPaidColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.taxAmount} />,
  accessor: taxPaidColumnId,
  cell: TaxPaid,
  width: 1.5,
});

export { taxPaidColumnId, taxPaidColumnDefinition };
